import React from "react";
import { Button, Card, Col } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { findIcon } from "../../../../dashboard/icons";
import { Swiper, SwiperSlide } from "swiper/react";
import { getRelativeDateFromNow } from "../../../../../common/utils/utils";
import { getContentIcon } from "../utils/commonFunctions";
import { fallbackImages } from "../../../../../common/constants/fallback-images";

const TopPerformingContents = ({ topPerformingContents = [] }) => {
  const { project_id } = useParams();

  return (
    <Card data-aos="fade-up" data-aos-delay="500">
      <Card.Body>
        <Col md={12} className="mb-3 d-flex justify-content-between">
          <h5 className="mb-1 poppins-medium" style={{ fontSize: 16 }}>
            Top Performing
          </h5>
          <Link
            to={`/sponsored-community/content/${project_id}`}
            className="ms-auto fs-6"
          >
            <span className="border-bottom border-primary">View All </span>
            <span className="transform-rotate-45">
              {findIcon("Arrow Up", "outline", 24)}
            </span>
          </Link>
        </Col>

        <div className="overflow-hidden d-slider1">
          <Swiper
            as="ul"
            className="p-0 m-0 mb-2 list-inline swiper-wrapper"
            slidesPerView={5}
            spaceBetween={15}
            navigation={false}
            breakpoints={{
              0: { slidesPerView: 1 },
              550: { slidesPerView: 2 },
              991: { slidesPerView: 2 },
              1400: { slidesPerView: 3 },
              1500: { slidesPerView: 3 },
              1920: { slidesPerView: 3 },
            }}
            data-aos="fade-up"
            data-aos-delay="700"
          >
            {topPerformingContents?.map((data = {}, key) => (
              <SwiperSlide key={`my-video-${key}`}>
                <div className=" border d-flex flex-column  rounded-3 p-3">
                  <div className="d-flex gap-3 align-items-center">
                    <div className="ratio ratio-1x1 border rounded-3 overflow-hidden w-90px flex-shrink-0">
                      <div className="w-100 h-100 d-flex align-items-center justify-content-center p-2">
                        <img
                          src={data?.thumbnail}
                          alt={data.content_title}
                          className="w-auto h-auto mw-100 mh-100"
                          onError={(e) =>
                            (e.target.src = fallbackImages.noImage)
                          }
                        />
                      </div>
                    </div>
                    <div className="d-flex flex-column justify-content-between flex-grow-1 overflow-hidden">
                      <div>
                        <Swiper
                          as="ul"
                          className="p-0 m-0 mb-2"
                          slidesPerView="auto"
                          spaceBetween={10}
                          data-aos="fade-up"
                          data-aos-delay="700"
                        >
                          <SwiperSlide
                            key={`content-type-1`}
                            style={{ width: "auto" }}
                          >
                            {data?.type && (
                              <span className="text-primary fs-7 bg-light rounded-pill badge bg-opacity-25 text-nowrap">
                                <span className="me-1">
                                  {getContentIcon(data?.type)}
                                </span>
                                <span className="fs-7 text-capitalize">
                                  {data?.type}
                                </span>
                              </span>
                            )}
                          </SwiperSlide>
                          {data?.specialities?.length > 0 && (
                            <SwiperSlide
                              key={`content-specialities-2`}
                              style={{ width: "auto" }}
                            >
                              {data?.specialities?.map((speciality, index) => (
                                <span
                                  key={`speciality-${index}`}
                                  className="text-primary fs-7 bg-light rounded-pill badge bg-opacity-25 text-nowrap me-1 text-capitalize"
                                >
                                  {speciality}
                                </span>
                              ))}
                            </SwiperSlide>
                          )}
                        </Swiper>
                      </div>

                      {data.title && (
                        <h5 className="fw-normal fs-6 two-line-clamp text-black mb-1 lh-sm">
                          {data.title}
                        </h5>
                      )}
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    {data?.published_at && (
                      <p className="m-0 fs-7" style={{ color: "#525252" }}>
                        <span>
                          {data?.views ?? 0} Views |{" "}
                          {getRelativeDateFromNow(data.published_at)}{" "}
                        </span>
                      </p>
                    )}

                    <Button
                      className="ms-auto rounded-2 px-3 py-1"
                      variant="primary"
                      size="sm"
                      onClick={() => window.open(data?.deeplink, "_blank")}
                    >
                      View
                    </Button>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </Card.Body>
    </Card>
  );
};

export default TopPerformingContents;
